import React, { useEffect } from 'react';
import Banner from './components/Banner';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import OrderPage from './pages/OrderPage';
import NotFoundPage from './pages/NotFoundPage';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Poster from './components/Poster';
import AdminOrders from './components/AdminOrders';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { initializeAnalytics } from './utils/analytics';

const App = () => {
    useEffect(() => {
        // Initialize analytics on app load
        initializeAnalytics();
    }, []);

    return (
        <Router>
            <ScrollToTop />
           
            <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
                <Navbar />
                <Switch>
                    <Route path="/" exact component={HomePage} />
                    <Route path="/order" component={OrderPage} />
                    <Route path="/poster" component={Poster} />
                    <Route path="/adminpro" component={AdminOrders} />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route path="/terms-of-service" component={TermsOfService} />
                    <Route component={NotFoundPage} />
                </Switch>
                <Footer />
            </div>
        </Router>
    );
};

export default App;